<script>
  import { onMount } from 'svelte'
  import { Headline, Video } from '@st-graphics/graphics-components'
  import { boolean } from '@st-graphics/graphics-kit/utils'

  let {
    navbar,
    byline,
    datetime,
    modifieddatetime,
    deck,
    headline,
    src,
    poster,
    menuitems,
    id = 'videohero',
    mobiledeck = 'false',
    videomode = 'brightcove',
    trailer = null,
    trailerhasdesktop = false,
    account = '4800266888001',
    hasdesktop = 'false',
    autoplay = false,
    loop = true,
    muted = true,
    classname = '',
    balancehed = true,
    balancedek = true,
    alt,
  } = $props()

  let videoOpen = $state(false)
  let mounted = $state(false)
  const openPlayer = () => {
    videoOpen = true
  }

  const closePlayer = () => {
    videoOpen = false
  }

  onMount(() => {
    mounted = true
  })
</script>

<div {id} class={`head-container ${classname}`}>
  {#if mounted}
    <div class="article-head" class:hidden={videoOpen}>
      <div class="nav">
        {@render navbar?.()}
        {@render menuitems?.()}
      </div>

      <div class="article-hero">
        {#if trailer}
          <Video
            src={trailer}
            {alt}
            hasdesktop={boolean(trailerhasdesktop)}
            autoplay={true}
            loop={true}
            {poster}
            muted={true}
            controls={false}
          />
        {/if}
        <div class="headline-container">
          <Headline
            hed={headline}
            dek={deck}
            {byline}
            {datetime}
            {modifieddatetime}
            mobiledeck={boolean(mobiledeck)}
            balancehed={boolean(balancehed)}
            balancedek={boolean(balancedek)}
          />
          <!-- svelte-ignore a11y_consider_explicit_label -->
          <button class="open-player" onclick={openPlayer} aria-label="Play video">
            <svg width="89" height="89" viewBox="0 0 89 89" aria-hidden="true">
              <g data-name="Group 2" transform="translate(0.5 0.5)">
                <circle
                  data-name="Ellipse 1"
                  cx="44"
                  cy="44"
                  r="44"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                  stroke-width="1"
                />
                <path
                  data-name="Path 1"
                  d="M35.616,31.575l25,12.5-25,12.5Z"
                  transform="translate(-0.075 -0.075)"
                  fill="#fff"
                />
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="background brightcove">
      {#if videomode === 'brightcove'}
        {#key videoOpen}
          <Video
            mode="brightcove"
            videoid={src}
            {alt}
            {account}
            autoplay={videoOpen}
            controls="nodownload"
            muted={boolean(muted)}
            loop={boolean(loop)}
            hasdesktop={boolean(hasdesktop)}
            id="video-hero-bc"
            {videoOpen}
          />
        {/key}
      {:else if videomode === 'iframe'}
        <Video
          mode="iframe"
          {src}
          {alt}
          {account}
          {autoplay}
          controls="nodownload"
          muted={boolean(muted)}
          loop={boolean(loop)}
          hasdesktop={boolean(hasdesktop)}
          id="video-hero-iframe"
        />
      {:else}
        <Video
          {src}
          {alt}
          {poster}
          controls={true}
          hasdesktop={boolean(hasdesktop)}
          id="video-hero-local"
        />
      {/if}

      <button
        class="close-player"
        class:hidden={!videoOpen}
        onclick={closePlayer}
        aria-label="Close video"
      >
        <svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true">
          <g fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1">
            <circle cx="20" cy="20" r="20" stroke="none" />
            <circle cx="20" cy="20" r="19.5" fill="none" />
          </g>
          <path
            d="M42.744,40.967l-1.751,1.751L36.1,37.83l-4.913,4.913L29.44,40.993l4.913-4.913-4.888-4.888,1.752-1.751L36.1,34.328l4.862-4.862,1.751,1.752-4.862,4.862Z"
            transform="translate(-16.093 -16.093)"
            fill="#fff"
          />
        </svg>
      </button>
    </div>
  {/if}
</div>

<style lang="scss">
  .nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;
    --navbar-color: var(--st-white);
    --brand-color: currentcolor;

    :global(a),
    :global(.menu) {
      color: #fff !important;
    }
    &::after {
      content: '';
      width: 100%;
      height: 500px;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(to bottom, rgb(0 0 0 / 50%), rgb(0 0 0 / 0%));
      z-index: -1;
    }
  }
  .head-container {
    --article-head-color: var(--st-white);
    --article-head-hero-overlay-background-color: rgb(0 0 0 /50%);
    --headline-dek-color: currentcolor;
    --headline-metadata-color: currentcolor;
    --link-color: currentcolor;
    position: relative;
    height: var(--article-head-hero-height, 100vh);
    color: var(--article-head-color);
    text-align: var(--article-head-text-align);
    background: var(--article-head-background);
    background-size: cover;

    // overlay part
    .article-head {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;

      &.hidden {
        opacity: 0;
        pointer-events: none;
      }

      .article-hero {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        &::after {
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 100%;
          content: '';
          background-color: var(--article-head-hero-overlay-background-color);
        }

        .headline-container {
          position: absolute;
          z-index: 99;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          :global(.headline) {
            text-align: center;
          }
        }
      }

      :global(.figure) {
        height: 100%;
        min-height: 100%;
      }
      :global(.videocontainer) {
        height: 100%;
        width: 100%;
      }
      :global(video) {
        width: 100%;
        height: 100%;
        max-width: unset !important;
        object-fit: cover;
      }
    }
    // Brightcove video part
    .background {
      width: 100%;
      height: 100%;
      opacity: 1;
      overflow: hidden;
      display: flex;
      align-content: center;
      flex-wrap: wrap;

      .close-player {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 9;
      }
      :global(.figure) {
        width: 100%;
        height: 100%;
        display: contents;
      }
      :global(.videocontainer) {
        width: 100%;
        height: 100%;
      }
    }

    :global(.headline .wrapper:last-of-type) {
      border: none;
    }
  }
</style>
